import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('ApiUrlToken');
